import styles from "src/components/organisms/ProfileInfo/styles.module.css";
import Avatar from "src/assets/images/avatar.svg";
import { Button, BUTTONTYPE } from "src/components/atoms/Button";
import { StatisticsBlock } from "src/components/molecules/StatisticsBlock";
import { useRedirect } from "src/navigation/useRedirect";
import { MODALS, PAGES } from "src/types/navigation";
import { useSelector } from "react-redux";
import { RootState } from "src/store";

export const ProfileInfo = () => {
  const { redirect } = useRedirect();
  const { openModal } = useRedirect();
  const handleEditClick = () => redirect({ scheme: PAGES.EDIT_PROFILE });
  const handleDepositClick = () => openModal({ scheme: MODALS.DEPOSIT });
  const handleWithdrowClick = () => openModal({ scheme: MODALS.WITHDRAW });
  const user = useSelector((state: RootState) => state.profile.user);

  return (
    <div className={styles.profile}>
      <div className={styles.imgWrapper}>
        <div className={styles.img}>
          <img src={user?.profile_picture ?? Avatar} alt="avatar" />
        </div>
        <div className={styles.edit}>
          <h3>{user?.username ?? "-"}</h3>
          <Button
            btnType={BUTTONTYPE.LIGHT}
            text={{ id: "components.organisms.ProfileInfo.edit" }}
            onClick={handleEditClick}
          />
        </div>
      </div>
      <div className={styles.btn}>
        <Button
          text={{ id: "components.organisms.ProfileInfo.deposit" }}
          onClick={handleDepositClick}
        />
        <Button
          btnType={BUTTONTYPE.LIGHT}
          text={{ id: "components.organisms.ProfileInfo.withdrow" }}
          onClick={handleWithdrowClick}
        />
      </div>
      <div className={styles.balanceInfo}>
        <StatisticsBlock />
      </div>
    </div>
  );
};
